var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMapsClient = function () {
  function GoogleMapsClient() {
    _classCallCheck(this, GoogleMapsClient);

    this._autocomplete = new window.google.maps.places.AutocompleteService();
    this._geocoder = new window.google.maps.Geocoder();
  }

  _createClass(GoogleMapsClient, [{
    key: 'autocomplete',
    value: function autocomplete(_ref) {
      var _this = this;

      var request = _ref.request;

      return new Promise(function (resolve, reject) {
        try {
          _this._autocomplete.getPlacePredictions(request, function (results, status) {
            if (status !== window.google.maps.GeocoderStatus.OK && status !== window.google.maps.GeocoderStatus.ZERO_RESULTS) {
              reject({ code: 'internal' });
            } else {
              resolve(results || []);
            }
          });
        } catch (e) {
          reject({ code: 'internal', message: e.message });
        }
      });
    }
  }, {
    key: 'geocode',
    value: function geocode(_ref2) {
      var _this2 = this;

      var request = _ref2.request;

      return new Promise(function (resolve, reject) {
        try {
          _this2._geocoder.geocode(request, function (results, status) {
            if (status !== window.google.maps.GeocoderStatus.OK && status !== window.google.maps.GeocoderStatus.ZERO_RESULTS) {
              reject({ code: 'internal' });
            } else {
              resolve(results || []);
            }
          });
        } catch (e) {
          reject({ code: 'internal', message: e.message });
        }
      });
    }
  }]);

  return GoogleMapsClient;
}();

export default GoogleMapsClient;
//# sourceMappingURL=GoogleMapsClient.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/clients/GoogleMapsClient.js